import moment from "moment"

export const toAmount = (value) => Number(value) || 0

export const formatAmount = (value, currency = "INR") =>
  toAmount(value).toLocaleString("en-IN", {
    style: "currency",
    currency,
    maximumFractionDigits: 0,
  })

export const formatDate = (value) =>
  value ? moment(value).format("MMM DD, YYYY") : "-"

export const formatShortDate = (value) =>
  value ? moment(value).format("DD MMM YYYY") : "-"

export const formatMonth = (value) =>
  value ? moment(value).format("MMMM YYYY") : "-"
